import { Link } from 'react-router-dom';
import { MailCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/atoms/button';

export default function SignupSuccessPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-8 bg-background">
      <div className="w-full max-w-md text-center">
        <Link to="/" className="flex items-end justify-center gap-2 mb-8">
          <img src="/volovolo.png" alt="Volovolo" className="h-10 w-auto" />
          <span className="font-bold text-xl">Pro</span>
        </Link>

        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-blue-100 flex items-center justify-center">
            <MailCheck className="w-12 h-12 text-blue-600" />
          </div>
        </div>

        <h1 className="text-2xl font-bold mb-2">
          {t('signupSuccess.title')}
        </h1>

        <p className="text-muted-foreground mb-4">
          {t('signupSuccess.description')}
        </p>

        <p className="text-sm text-muted-foreground mb-8">
          {t('signupSuccess.checkInbox')}
        </p>

        <div className="flex flex-col gap-3">
          <Button asChild className="w-full">
            <Link to="/login">{t('signupSuccess.goToLogin')}</Link>
          </Button>
          <Button asChild variant="ghost" className="w-full">
            <Link to="/resend-activation">{t('signupSuccess.resendLink')}</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
